module.exports = __webpack_public_path__ + "f12.jpg?2c5f77cb903c8431d03c06b710bcc555";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f12.jpg
// module id = 1580
// module chunks = 0